import "bootstrap/dist/css/bootstrap.css";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import { Router, Route, Switch } from "react-router-dom";
import Home from "./Components/Home/Home";
import { history } from "./Healper/history";
import PreliminaryData from "./Components/registeration/userData/userPrelimirary";
import PatientPreliminaryCode from "./Components/registeration/userData/userPreliminaryCode";
import EmailLinkVerification from "./Components/registeration/emailLinkVerification/emailLinkVerification";

function App() {
  return (
    <div className={`App `}>
      <LocalizationProvider dateAdapter={AdapterDateFns}></LocalizationProvider>
      <div className="app-row">
        <div className="context-expanded">
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route
                exact
                path="/EmailVerification/:key"
                component={EmailLinkVerification}
              />
              <Route
                exact
                path="/PreRegistration"
                component={PreliminaryData}
              />
              <Route
                exact
                path="/PatientPreliminaryCode"
                component={PatientPreliminaryCode}
              />
            </Switch>
          </Router>
        </div>
      </div>
    </div>
  );
}

export default App;
